import React from 'react'
import { Button, Tooltip, Position, Icon, Intent, AnchorButton } from '@blueprintjs/core'

const BPButton = ({ type, className, label, intent, tooltip, icon, iconSize, rightIcon, minimal, small, large, outlined, onClick, disabled, fill, href, target, buttonRef }) => {
  const anchorOrButton = href
    ? (
      <AnchorButton
        href={href}
        target={`${target || '_blank'}`}
        className={`${className || 'bp3AnchorButton'}`}
        icon={<Icon icon={icon} iconSize={iconSize || 14} />}
        rightIcon={rightIcon || null}
        intent={intent || Intent.NONE}
        disabled={disabled}
        text={label}
        small={small}
        large={large}
        minimal={minimal}
        outlined={outlined}
        fill={fill}
        onClick={onClick}
        ref={buttonRef}
      />
    )
    : (
      <Button
        disabled={disabled}
        type={type}
        className={className}
        icon={<Icon icon={icon} iconSize={iconSize || 14} />}
        rightIcon={rightIcon || null}
        intent={intent || Intent.NONE}
        text={label}
        small={small}
        large={large}
        minimal={minimal}
        outlined={outlined}
        fill={fill}
        onClick={onClick}
        ref={buttonRef}
      />
    )

  return (
    <Tooltip popoverClassName='blueprintTooltip' content={tooltip} position={Position.BOTTOM} disabled={tooltip == null || tooltip === ''}>
      {anchorOrButton}
    </Tooltip>
  )
}

export default BPButton
